// Replace with your Firebase config
export const firebaseConfig = {
  apiKey: "AIzaSyAn5XAaW862n9BeXxRMctKngtDj4_V-Wds",
  authDomain: "ben-camara.firebaseapp.com",
  projectId: "ben-camara",
  storageBucket: "ben-camara.appspot.com",
  messagingSenderId: "243794165179",
  appId: "1:243794165179:web:3b51ea41782c1821c1589e",
  measurementId: "G-TJ6T35X663"
};



export const firebaseConfigSandbox = {
  apiKey: "AIzaSyCQ1z_32C8PWLe5PpI__IHzDGq724DcLv0",
  authDomain: "ben-camara-sandbox.firebaseapp.com",
  projectId: "ben-camara-sandbox",
  storageBucket: "ben-camara-sandbox.appspot.com",
  messagingSenderId: "569401779272",
  appId: "1:569401779272:web:9d48ca5a95810d99eea47d",
  measurementId: "G-BF74YHWZB5"
};
